<template>
  <div class="_contenter">
    <div class="sub-title">售后方案</div>
    <div v-if="!isReturn">
      <div>
        <div class="tab-space">
          <div
            class="sub-tab"
            v-for="(item, index) in afterSalesSolution"
            :key="index"
            @click="
              () => {
                if (
                  orderData.status !==
                  dictMap['pre_inspection_of_receiving_goods'].id
                )
                  return;
                info.afterSalesSolution = item.id;
                radio = index;
              }
            "
            :class="{
              'active-tab': radio == index,
              'unavailable-tab':
                item.id !== info.afterSalesSolution &&
                orderData.status !==
                  dictMap['pre_inspection_of_receiving_goods'].id,
            }"
          >
            {{ item.name }}
          </div>
        </div>
        <el-row
          v-if="
            info.afterSalesSolution &&
            [dictMap['repair'].id, dictMap['goods_return'].id].includes(
              info.afterSalesSolution
            ) &&
            orderData.status !== dictMap['pre_inspection_of_receiving_goods'].id
          "
        >
          <editOrderLog :afterSaleOrder="orderData"></editOrderLog>
        </el-row>
        <div class="" v-if="radio == 1 || radio == 2">
          <el-form
            ref="form"
            :rules="rules"
            :model="info"
            label-width="80px"
            label-position="top"
            v-if="radio == 1"
          >
            <el-row :gutter="20" style="padding-top: 10px">
              <el-col :span="24" v-if="isShowExangeDesc">
                <el-form-item label="换货说明" prop="description">
                  <el-input
                    type="textarea"
                    v-model="info.description"
                    placeholder="请输入换货说明，限制200字符。"
                    :rows="2"
                    maxlength="200"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-else>
                <editOrderLog :afterSaleOrder="orderData"></editOrderLog>
              </el-col>
            </el-row>
          </el-form>
          <div class="_reason" v-if="radio == 2">
            <el-row>
              <el-form
                ref="form"
                :rules="rules"
                :model="info"
                label-width="80px"
                label-position="top"
                v-if="
                  orderData.status ===
                  dictMap['pre_inspection_of_receiving_goods'].id
                "
              >
                <el-form-item label="退还原因" prop="reason">
                  <el-select
                    clearable
                    v-model="info.reason"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in reasonforRefund"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-row>
          </div>
        </div>
        <div
          v-if="
            radio == 1 &&
            !isShowExangeDesc &&
            ![dictMap['to_be_returned'].id, dictMap['returned'].id].includes(
              orderData.status
            )
          "
        >
          <div class="_reason tab-space">
            <div
              class="sub-tab"
              v-for="(item, index) in exchangeSolution"
              :key="item.id"
              @click="
                () => {
                  if (orderData.status !== dictMap['pending_review'].id) return;
                  isAgree = index + 1;
                  info.exchangeSolution = item.id;
                }
              "
              :class="{
                'active-tab': isAgree == index + 1,
                'unavailable-tab':
                  item.id !== info.exchangeSolution &&
                  [
                    dictMap['to_be_sent_out'].id,
                    dictMap['sent_out'].id,
                    dictMap['process_status'].id,
                    dictMap['to_be_returned'].id,
                    dictMap['returned'].id,
                  ].includes(orderData.status),
              }"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="_reason" v-if="isAgree == 2">
            <el-row>
              <el-form
                ref="form"
                :rules="rules"
                :model="info"
                label-width="80px"
                label-position="top"
              >
                <el-form-item label="拒绝换货原因" prop="reason">
                  <el-select
                    :disabled="
                      orderData.status !== dictMap['pending_review'].id
                    "
                    clearable
                    v-model="info.reason"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in reasonforRefusal"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-row>
          </div>
          <el-row
            v-if="
              isAgree == 2 &&
              info.reason == dictMap['reason_for_refusing_exchange_other'].id
            "
            style="margin-top: -20px"
          >
            <el-col :span="24">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入其他原因，限制4-200字符"
                v-model="info.description"
                minlength="4"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-row
        v-if="
          radio == 2 &&
          info.reason == dictMap['reason_for_refund_other'].id &&
          orderData.status === dictMap['pre_inspection_of_receiving_goods'].id
        "
        style="margin-top: -20px"
      >
        <el-col :span="24">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入其他原因，限制4-200字符"
            v-model="info.description"
            minlength="4"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-col>
      </el-row>
      <div
        v-if="
          [dictMap['to_be_sent_out'].id, dictMap['sent_out'].id].includes(
            orderData.status
          ) && info.afterSalesSolution === dictMap['exchange_goods'].id
        "
        style="margin-top: 20px"
      >
        <div class="sub-title">选择换货设备</div>
        <el-table
          v-if="
            orderData.status === dictMap['to_be_sent_out'].id &&
            info.exchangeSolution === dictMap['agree_exchange'].id
          "
          v-loading="loading"
          empty-text="暂无数据"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="设备编码"
            width="200"
            prop="code"
          >
            <template #header>
              <span><span style="color: #f56c6c">* </span>设备编码</span>
            </template>
            <template slot-scope="coding">
              <el-autocomplete
                clearable
                v-model="exchangeDevInfo.coding"
                :fetch-suggestions="devCodeSearchList"
                placeholder="请输入设备编码"
                @select="handleSelect"
              ></el-autocomplete>
              <!-- <el-form :model="exchangeDevInfo" :rules="rules" ref="form">
              <el-form-item prop="coding">
                <el-autocomplete
                  clearable
                  v-model="exchangeDevInfo.coding"
                  :fetch-suggestions="devCodeSearchList"
                  placeholder="请输入设备编码"
                  @select="handleSelect"
                ></el-autocomplete>
              </el-form-item>
            </el-form> -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="设备型号"
            ><template slot-scope="scope">
              {{ scope.row.code_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="SN" width="185">
            <template slot-scope="sn">
              <el-autocomplete
                clearable
                v-model="exchangeDevInfo.sn"
                :fetch-suggestions="SNSearchList"
                placeholder="请输入SN"
                @select="handleSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="IMEI"
            prop="customerName"
            width="170"
          >
            <template slot-scope="imei">
              <el-autocomplete
                clearable
                v-model="exchangeDevInfo.imei"
                :fetch-suggestions="IMEISearchList"
                placeholder="请输入IMEI编码"
                @select="handleSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="MAC地址"
            prop="mac"
            width="185"
          >
            <template slot-scope="mac">
              <el-autocomplete
                clearable
                v-model="exchangeDevInfo.mac"
                :fetch-suggestions="MACSearchList"
                placeholder="请输入MAC地址"
                @select="handleSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="批次号"
            prop="batch_number"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.batch_number || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="固件版本"
            prop="firmware_version"
          >
            <template slot-scope="scope">
              {{ scope.row.firmware_version || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="绑定用户"
            prop="device.imei"
            width="120"
          >
            <template slot-scope="scope">
              {{ getBindUser(scope.row.bindUsers) || "-" }}
              <!-- <el-popover
              v-if="scope.row.bindUsers"
              trigger="hover"
              placement="top"
            >
              <div v-if="scope.row.bindUsers">
                <el-button
                  v-for="(item, index) in scope.row.bindUsers"
                  :key="index"
                  type="text"
                  @click="toUserDetail(scope.row, index)"
                  >{{ item.name }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></el-button
                >
              </div>
              <div slot="reference">
                <div
                  v-if="scope.row.bindUsers"
                  style="
                    width: 90px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <span
                    v-for="(item, index) in scope.row.bindUsers"
                    :key="index"
                    type="text"
                    @click="goUserDetail(scope.row, index)"
                    style="color: #165dff; cursor: pointer"
                    >{{ item.name
                    }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></span
                  >
                </div>
              </div>
            </el-popover>
            <div v-else>--</div> -->
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="激活日期"
            prop="created_at"
            width="170"
          >
            <template slot-scope="scope">
              {{ scope.row.first_bind_time || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="保修" prop="warranty">
            <template slot-scope="scope">
              {{ scope.row.warranty || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-else
          v-loading="loading"
          empty-text="暂无数据"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="设备编码"
            width="180"
            prop="coding"
          >
            <template slot-scope="scope">
              <span
                class="click-table-item"
                @click="clickTableItem(scope.row)"
                >{{ scope.row.coding || "--" }}</span
              >
            </template>
            <!-- <template slot-scope="scope">
            {{ scope.row.coding || "--" }}
          </template> -->
            <!-- <template #header>
            <span><span style="color: #f56c6c">* </span>设备编码</span>
          </template> -->
          </el-table-column>
          <el-table-column align="center" label="设备型号"
            ><template slot-scope="scope">
              {{ scope.row.code_name || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="SN" width="170">
            <template slot-scope="scope">
              {{ scope.row.sn || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="IMEI"
            prop="customerName"
            width="170"
          >
            <template slot-scope="scope">
              {{ scope.row.imei || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="MAC地址"
            prop="mac"
            width="170"
          >
            <template slot-scope="scope">
              {{ scope.row.mac || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="批次号"
            prop="batch_number"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.batch_number || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="固件版本"
            prop="firmware_version"
          >
            <template slot-scope="scope">
              {{ scope.row.firmware_version || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="绑定用户" width="200">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.bindUsers"
                trigger="hover"
                placement="top"
              >
                <div v-if="scope.row.bindUsers">
                  <el-button
                    v-for="(item, index) in scope.row.bindUsers"
                    :key="index"
                    type="text"
                    @click="toUserDetail(item, index)"
                    >{{ item.name
                    }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                      >、</span
                    ></el-button
                  >
                </div>
                <div slot="reference">
                  <div
                    v-if="scope.row.bindUsers"
                    style="
                      width: 165px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <span
                      v-for="(item, index) in scope.row.bindUsers"
                      :key="index"
                      type="text"
                      @click="toUserDetail(item, index)"
                      style="color: #165dff; cursor: pointer"
                      >{{ item.name
                      }}<span v-if="index + 1 !== scope.row?.bindUsers.length"
                        >、</span
                      ></span
                    >
                  </div>
                </div>
              </el-popover>
              <div v-else>--</div>
              <!-- <div
                v-if="scope.row.bindUsers && scope.row.bindUsers.length > 0"
                class="bind-user"
              >
                <span
                  v-for="(i, index) in scope.row.bindUsers"
                  @click="toUserDetail(i)"
                  :key="index"
                  class="user-name click-table-item"
                  >{{ i.name
                  }}<span v-if="index < scope.row.bindUsers.length - 1"
                    >、</span
                  >
                </span>
              </div>
              <div v-else>--</div> -->
            </template>
            <!-- <template slot-scope="scope">
            {{ getBindUser(scope.row.bindUsers) || "--" }}
          </template> -->
          </el-table-column>
          <el-table-column
            align="center"
            label="激活日期"
            prop="created_at"
            width="170"
          >
            <template slot-scope="scope">
              {{ scope.row.firstBindTime || "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="保修" prop="warranty">
            <template slot-scope="scope">
              {{ scope.row.warranty || "--" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-else>
      <div
        class="tab-space"
        v-if="
          ![dictMap['returned_inventory'].id, dictMap['returned'].id].includes(
            orderData.status
          )
        "
      >
        <div
          class="sub-tab"
          v-for="(item, index) in returnSolution"
          :key="index"
          @click="
            () => {
              if (
                orderData.status !==
                dictMap['pre_inspection_of_receiving_goods'].id
              )
                return;
              info.afterSalesSolution = item.id;
              radio = index;
            }
          "
          :class="{
            'active-tab': radio == index,
            'unavailable-tab':
              item.id !== info.afterSalesSolution &&
              orderData.status !==
                dictMap['pre_inspection_of_receiving_goods'].id,
          }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="tab-space" v-else style="display: block">
        <editOrderLog :afterSaleOrder="orderData"></editOrderLog>
      </div>
      <div
        class="_reason"
        v-if="
          (radio == 1 &&
            [dictMap['pre_inspection_of_receiving_goods'].id].includes(
              orderData.status
            )) ||
          (info.afterSalesSolution == dictMap['reject_return'].id &&
            [dictMap['returned'].id].includes(orderData.status))
        "
      >
        <el-row>
          <el-form
            ref="form"
            :rules="rules"
            :model="info"
            label-width="80px"
            label-position="top"
          >
            <el-form-item label="拒绝退货原因" prop="reason">
              <el-select
                :disabled="
                  orderData.status !==
                  dictMap['pre_inspection_of_receiving_goods'].id
                "
                clearable
                v-model="info.reason"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in reasonforRefusalofReturn"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <editOrderLog
        v-if="[dictMap['to_be_returned'].id].includes(orderData.status)"
        :afterSaleOrder="orderData"
      ></editOrderLog>
      <el-row
        v-if="
          info.reason == dictMap['reason_for_refusal_of_return_other'].id &&
          (orderData.status === dictMap['pending_review'].id ||
            orderData.status ===
              dictMap['pre_inspection_of_receiving_goods'].id)
        "
        style="margin-top: -20px"
      >
        <el-col :span="24">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入其他原因，限制4-200字符"
            v-model="info.description"
            minlength="4"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import editOrderLog from "../components/editOrderLog.vue";
import { getDictMap } from "../../../utils/util";
export default {
  name: "afterSalePlan",
  components: {
    editOrderLog,
  },
  props: {
    orderData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tableData: [{}],
      exchangeDevInfo: {
        coding: "",
        sn: "",
        imei: "",
        mac: "",
      },
      loading: false,
      radio: 0,
      isAgree: 1,
      isReturn: true,
      isShowExangeDesc: true,
      // editableList: [
      //   this.dictMap["to_be_sent_out"].id,
      //   this.dictMap["sent_out"].id,
      // ],
      textarea: "",
      reason: [],
      value: "",
      rejectExchange: [],
      afterSalesSolution: [],
      reasonforRefusal: [],
      exchangeSolution: [],
      reasonforRefund: [],
      returnSolution: [],
      reasonforRefusalofReturn: [],
      rejectExchangeValue: "",
      info: {
        afterSalesSolution: "",
        description: "", //换货描述/退货原因说明
        exchangeSolution: "", //换货方案
        reason: "", //拒绝换货原因
        exchangeGdid: "", //更换设备的gdid
      },
      rules: {
        description: [
          { required: true, message: "请输入换货说明", trigger: "blur" },
        ],
        description1: [
          { required: true, message: "请输入其他原因", trigger: "blur" },
        ],
        reason: [{ required: true, message: "请输入原因", trigger: "change" }],
      },
      statusLog: [],
      processStatus: [],
      dictMap: {},
    };
  },
  watch: {
    radio(newValue) {
      if (newValue === 0 || newValue === 2) {
        this.info.description = "";
      }
    },
    orderData(newVal) {
      if (newVal) {
        const curStatus =
          newVal.status ==
          this.dictMap["pre_inspection_of_receiving_goods"]?.id; //收货预检状态
        this.isShowExangeDesc = curStatus;
        // this.isTobeSendOut = newVal.status == "66ebda5847bb18482f161420"; //是否是待寄出状态
        this.isReturn = newVal.category == this.dictMap["return_request"]?.id; //是否是退货

        if (newVal.statusLog) {
          this.statusLog = newVal.statusLog;
          for (const i of newVal.statusLog) {
            if (i.afterSalesSolution) {
              this.info.afterSalesSolution = i.afterSalesSolution;
              console.log(
                "this.info.afterSalesSolution",
                this.info.afterSalesSolution
              );

              if (
                i.afterSalesSolution == this.dictMap["repair"]?.id ||
                i.afterSalesSolution == this.dictMap["agree_return"]?.id
              ) {
                this.radio = 0;
              } else if (
                i.afterSalesSolution == this.dictMap["exchange_goods"]?.id ||
                i.afterSalesSolution == this.dictMap["reject_return"]?.id
              ) {
                this.radio = 1;

                if (this.orderData.status == this.dictMap["returned"]?.id) {
                  this.radio = 0;
                  console.log("this.radio执行了");
                }
                if (
                  this.orderData.status == this.dictMap["returned"]?.id &&
                  i.afterSalesSolution == this.dictMap["exchange_goods"]?.id
                ) {
                  this.radio = 1;
                  console.log("this.radio执行了2");
                }
              } else if (
                i.afterSalesSolution == this.dictMap["goods_return"]?.id
              ) {
                this.radio = 2;
              }
            }
            if (i.description) {
              this.info.description = i.description;
            }
            if (i.exchangeSolution) {
              if (i.exchangeSolution === this.dictMap["agree_exchange"]?.id) {
                this.isAgree = 1;
              } else if (
                i.exchangeSolution === this.dictMap["reject_exchange"]?.id
              ) {
                this.isAgree = 2;
              }
            }
            if (i.reason) {
              this.info.reason = i.reason;
            }
          }
        }
        this.initAfterSalesSolution();
        if (!curStatus) {
          this.info.description = ""; //不是收货预检状态描述就清空
        }
        const device = newVal.exchangeDevice;
        if (newVal.status === this.dictMap["to_be_sent_out"]?.id) {
          this.tableData = [{}];
        } else {
          this.tableData = [
            {
              ...device,
              batch_number: device.batchNumber,
              created_at: device.firstBindTime,
              firmware_version: device.firmwareVersion,
            },
          ];
        }
      }
    },
  },
  created() {
    // this.getDict();
    this.dictMap = getDictMap();
  },
  mounted() {
    this.getDict();
    // this.initAfterSalesSolution();
  },
  methods: {
    toUserDetail(item) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: item.id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    initAfterSalesSolution() {
      if (this.isReturn) {
        this.info.afterSalesSolution =
          this.returnSolution[this.radio]?.id || null;
      } else {
        console.log("this.radio22", this.radio);

        this.info.afterSalesSolution =
          this.afterSalesSolution[this.radio]?.id || null;
        this.info.exchangeSolution = this.exchangeSolution[0]?.id;
        // console.log(
        //   "this.info.afterSalesSolution2",
        //   this.info.afterSalesSolution
        // );
      }
    },
    clickTableItem(item) {
      if (this.$jumpPerm("device_detail")) {
        this.$router.push({
          path: "/devDetail",
          query: {
            id: item.id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getBindUser(list) {
      if (list && list.length > 0) {
        return list.map((i) => i.name).join("、");
      } else {
        return "";
      }
    },
    handleSelect(item) {
      this.tableData = [item];
      const { coding, sn, imei, mac, _id } = item;

      this.exchangeDevInfo = {
        coding,
        sn,
        imei,
        mac,
        gdid: _id,
      };
      this.info.exchangeGdid = _id;
    },
    devCodeSearchList(queryString, cb) {
      this.searchList(queryString, cb, 1);
    },
    SNSearchList(queryString, cb) {
      this.searchList(queryString, cb, 2);
    },
    IMEISearchList(queryString, cb) {
      this.searchList(queryString, cb, 3);
    },
    MACSearchList(queryString, cb) {
      this.searchList(queryString, cb, 4);
    },
    searchList(queryString, cb, type) {
      // console.log("queryString", queryString)
      if (queryString) {
        this.getDevList(queryString, cb, type);
      } else {
        cb([]);
      }
    },
    getDevList(queryString, cb, type) {
      const params =
        {
          1: { coding: queryString },
          2: { sn: queryString },
          3: { imei: queryString },
          4: { mac: queryString },
        }[type] || {};

      this.$get("/device/lists", {
        page: 1,
        size: 5,
        ...params,
      }).then((res) => {
        const list = res.data.data.list;
        const arr = list.map((i) => ({
          ...i,
          value: i[Object.keys(params)[0]],
        }));
        cb && cb(arr);
      });
    },
    handTime(time) {
      return dayjs(time).format("YYYY.MM.DD HH:mm") || "";
    },
    getStatusName(id) {
      return this.processStatus.find((i) => i.id === id)?.name; // 使用可选链避免报错
    },
    getDict() {
      this.afterSalesSolution = this.dictMap["after_sales_solution"]?.children;

      this.processStatus = this.dictMap["process_status"]?.children;
      this.reasonforRefusal =
        this.dictMap["reason_for_refusing_exchange"]?.children;

      this.exchangeSolution = this.dictMap["exchange_solution"]?.children;

      this.reasonforRefund = this.dictMap["reason_for_refund"]?.children;

      this.returnSolution = this.dictMap["return_solution"]?.children;
      this.reasonforRefusalofReturn =
        this.dictMap["reason_for_refusal_of_return"]?.children;
    },
  },
};
</script>

<style lang="less" scoped>
._contenter {
  padding: 20px 20px 50px;
  box-sizing: border-box;
  margin-top: 16px;
}
.sub-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
}
.tab-space {
  display: flex;
  .sub-tab {
    width: 88px;
    height: 32px;
    background: #f2f3f5;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    margin-right: 8px;
    cursor: pointer;
  }
  .active-tab {
    color: #ffffff;
    background: #165dff;
  }
}
._reason {
  width: 30%;
  margin: 15px 0;
}
.reason-title {
  margin: 15px 0;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    // background: #f2f3f5;
    // border: none;
  }
}
::v-deep .el-input__count {
  line-height: 12px;
  //background: #f2f3f5 !important;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}
.order-log {
  display: flex;
  align-items: center;
  border-radius: 2px;
  margin-bottom: 10px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  background-color: #e8ffea;
  padding: 10px 16px;
  box-sizing: border-box;
  .order-log-date {
    margin-right: 10px;
  }
}
.unavailable-tab {
  background-color: #f7f8fa !important;
  color: #c9cdd4 !important;
  cursor: not-allowed !important;
}
.click-table-item {
  color: #165dff;
  cursor: pointer;
}
</style>
